<template>
  <div>
    <el-dialog
      class="modal"
      title="導出數據"
      :visible.sync="exportModal"
      width="375px"
    >
      <el-date-picker
        style="width:100%;margin:10px 0;"
        value-format="yyyy-M"
        v-model="exportDate"
        type="month"
        :picker-options="{ disabledDate: $store.state.disabledDate }"
      >
      </el-date-picker>
      <el-input
        v-if="
          $store.state.userStatus != 'customer' &&
            $store.state.userStatus != 'customerSub'
        "
        placeholder="用戶號"
        v-model="exportId"
        autocomplete="off"
      ></el-input>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="exportModal = false" class="btn">關閉</div>
        <div @click="confirmExport" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-form :inline="true" :model="searchData" class="demo-form-inline">
      <el-form-item
        label="用戶號"
        v-if="
          $store.state.userStatus != 'customer' &&
            $store.state.userStatus != 'customerSub'
        "
      >
        <el-input v-model="searchData.customer_id" placeholder="請輸入用戶號">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="currentDate"
          type="daterange"
          value-format="yyyy-MM-dd"
          start-placeholder="開始時間"
          end-placeholder="結束時間"
          :picker-options="{ disabledDate: $store.state.disabledDate }"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            inSearch = true;
            saveData = false;
            getData();
          "
          >搜尋</el-button
        >
      </el-form-item>
    </el-form>
    <el-button
      size="mini"
      @click="
        exportModal = true;
        exportId = '';
        exportDate = '';
      "
      >導出月報表</el-button
    >
    <h2 class="title" style="margin-top:15px">代收</h2>
    <el-table
      :data="list"
      style="width: 100%;margin-bottom: 20px;"
      :span-method="arraySpanMethod"
      :summary-method="getSummaries"
      show-summary
      border
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table
            class="table-in-table"
            :data="props.row.children"
            style="width: 100%;"
            row-key="id"
            border
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="date"
              label="日期"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="s_today"
              label="結餘"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.s_today | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="s_yesterday"
              label="初始餘額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.s_yesterday | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="c_amount"
              label="代收成功金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.c_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="c_fee"
              label="代收手續費"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.c_fee | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="m_add_amount"
              label="手動增加金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.m_add_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="m_reduce_amount"
              label="手動減少金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.m_reduce_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="unfreeze_amount"
              label="解凍金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.unfreeze_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="freeze_amount"
              label="凍結金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.freeze_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="user_id"
        label="用戶號"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="user_name"
        label="用戶名"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="s_today"
        label="結餘"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.s_today | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="s_yesterday"
        label="初始餘額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.s_yesterday | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="c_amount"
        label="代收成功金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.c_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="c_fee"
        label="代收手續費"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.c_fee | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="m_add_amount"
        label="手動增加金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.m_add_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="m_reduce_amount"
        label="手動減少金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.m_reduce_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="unfreeze_amount"
        label="解凍金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.unfreeze_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="freeze_amount"
        label="凍結金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.freeze_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <h2 class="title">代付</h2>
    <el-table
      :data="list"
      style="width: 100%;margin-bottom: 20px;"
      :span-method="arraySpanMethod"
      :summary-method="getSummaries2"
      show-summary
      border
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table
            class="table-in-table"
            :data="props.row.children"
            style="width: 100%;"
            row-key="id"
            border
          >
            <el-table-column
              eader-align="center"
              align="center"
              prop="date"
              label="日期"
            >
            </el-table-column>
            <el-table-column
              eader-align="center"
              align="right"
              prop="s_today"
              label="結餘"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.s_today | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="s_yesterday"
              label="初始餘額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.s_yesterday | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              label="代付成功金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.p_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              label="代付駁回金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.p_reject_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="c_fee"
              label="代付手續費"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.p_fee | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="c_fee"
              label="代付駁回手續費"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.p_reject_fee | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="m_add_amount"
              label="手動增加金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.m_add_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="m_reduce_amount"
              label="手動減少金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.m_reduce_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="unfreeze_amount"
              label="解凍金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.unfreeze_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="right"
              prop="freeze_amount"
              label="凍結金額"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.freeze_amount | decimalPoint | thousands }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column
        eader-align="center"
        align="center"
        prop="user_id"
        label="用戶號"
      >
      </el-table-column>
      <el-table-column
        eader-align="center"
        align="center"
        prop="user_name"
        label="用戶名"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="s_today"
        label="結餘"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.s_today | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="s_yesterday"
        label="初始餘額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.s_yesterday | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="right" label="代付成功金額">
        <template slot-scope="scope">
          <div>
            {{ scope.row.p_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="right" label="代付駁回金額">
        <template slot-scope="scope">
          <div>
            {{ scope.row.p_reject_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="c_fee"
        label="代付手續費"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.p_fee | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="c_fee"
        label="代付駁回手續費"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.p_reject_fee | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="m_add_amount"
        label="手動增加金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.m_add_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="m_reduce_amount"
        label="手動減少金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.m_reduce_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="unfreeze_amount"
        label="解凍金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.unfreeze_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="right"
        prop="freeze_amount"
        label="凍結金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.freeze_amount | decimalPoint | thousands }}
          </div>
        </template>
      </el-table-column>
      reduce
    </el-table>
    <div class="page">
      <el-pagination
        :current-page.sync="page"
        layout="prev, pager, next"
        :page-count="pagination.total_page"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchData: {},
      saveData: false,
      inSearch: false,
      page: 1,
      dataList: [],
      currentDate: [],
      list: [],
      exportModal: false,
      exportId: "",
      exportDate: "",
      reduce: {},
      pagination: {}
    };
  },
  watch: {
    page() {
      if (this.inSearch) {
        this.inSearch = false;
        return;
      }
      this.getData();
    }
  },
  methods: {
    getSummaries2(param) {
      const { columns } = param;

      const sums = [];

      columns.forEach((column, index) => {
        switch (index) {
          case 0:
            sums[index] = "";

            break;

          case 1:
            sums[index] = "合計";

            break;

          case 2:
            sums[index] = "";

            break;

          case 3:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.s_today)
            );
            break;

          case 4:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.s_yesterday)
            );
            break;

          case 5:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.p_amount)
            );

            break;

          case 6:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.p_reject_amount)
            );
            break;

          case 7:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.p_fee)
            );
            break;
          case 8:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.p_reject_fee)
            );
            break;
          case 9:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.m_add_amount)
            );
            break;

          case 10:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.m_reduce_amount)
            );
            break;
          case 11:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.unfreeze_amount)
            );
            break;
          case 12:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.freeze_amount)
            );
            break;
        }
      });

      return sums;
    },
    getSummaries(param) {
      const { columns } = param;

      const sums = [];

      columns.forEach((column, index) => {
        switch (index) {
          case 0:
            sums[index] = "";

            break;

          case 1:
            sums[index] = "合計";

            break;

          case 2:
            sums[index] = "";

            break;

          case 3:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.s_today)
            );
            break;

          case 4:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.s_yesterday)
            );
            break;

          case 5:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.c_amount)
            );

            break;

          case 6:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.c_fee)
            );
            break;

          case 7:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.m_add_amount)
            );
            break;
          case 8:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.m_reduce_amount)
            );
            break;
          case 9:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.unfreeze_amount)
            );
            break;

          case 10:
            sums[index] = this.$options.filters.thousands(
              this.$options.filters.decimalPoint(this.reduce.freeze_amount)
            );
            break;
        }
      });

      return sums;
    },
    confirmExport() {
      if (!this.exportDate) {
        this.$message.error("請選擇月份");
        return;
      }
      let month = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];

      // if (
      //   this.$store.state.userStatus == "customer" ||
      //   this.$store.state.userStatus == "customerSub"
      // ) {
      //   this.exportId = this.$store.state.selfInfo.id;
      // }
      this.$http
        .post(`/back/customers/getDailySummary`, {
          customer_id: this.exportId,
          year: this.exportDate.split("-")[0],
          month: month[this.exportDate.split("-")[1] * 1 - 1]
        })
        .then(res => {
          if (res.data.code == 0) {
            window.open(`/back/export/${res.data.data}`);
          }
        });
    },
    arraySpanMethod({ row, columnIndex }) {
      if (!row.children) {
        if (columnIndex === 0) {
          return [0, 0];
        } else if (columnIndex === 1) {
          return [1, 2];
        }
      }
    },
    getData() {
      let searchData = {};
      if (this.saveData) {
        searchData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        searchData = JSON.parse(JSON.stringify(this.searchData));
        if (this.currentDate) {
          searchData.date_start = this.currentDate[0];
          searchData.date_end = this.currentDate[1];
        }
      }
      Object.keys(searchData).forEach(e => {
        if (!searchData[e] && String(searchData[e]) !== "0") {
          delete searchData[e];
        }
      });
      if (
        this.$store.state.userStatus == "customer" ||
        this.$store.state.userStatus == "customerSub"
      ) {
        searchData.customer_id = this.$store.state.selfInfo.id;
      }
      searchData.page = this.page;
      this.$http
        .post(`/back/customers/getDailySummary`, searchData)
        .then(res => {
          if (res.data.code == 0) {
            let list = {};
            let endList = [];
            let reduce = {};
            let ddata = res.data.data;
            if (!Array.isArray(ddata)) {
              ddata = Object.values(ddata);
            }
            ddata.forEach(e => {
              let dataa = JSON.parse(JSON.stringify(e));
              let have = true;
              if (!list[dataa.user_id]) {
                list[dataa.user_id] = dataa;
                list[dataa.user_id].children = [];
                have = false;
              }

              Object.keys(dataa).forEach(key => {
                if (
                  key != "id" &&
                  key != "user_id" &&
                  key != "user_name" &&
                  key != "updated_at" &&
                  key != "currency" &&
                  key != "date" &&
                  typeof (dataa[key] * 1) == "number"
                ) {
                  reduce[key] = (reduce[key] * 1 || 0) + dataa[key] * 1;
                }
              });
              list[dataa.user_id].children.push(e);
              if (have) {
                Object.keys(dataa).forEach(key => {
                  if (
                    key != "id" &&
                    key != "user_id" &&
                    key != "user_name" &&
                    key != "updated_at" &&
                    key != "currency" &&
                    key != "date" &&
                    typeof (dataa[key] * 1) == "number"
                  ) {
                    list[dataa.user_id][key] =
                      list[dataa.user_id][key] * 1 + dataa[key] * 1;
                  }
                });
              }
            });
            Object.keys(list).forEach(e => {
              endList.push(list[e]);
            });
            this.reduce = reduce;
            this.list = endList;
            this.saveData = JSON.parse(JSON.stringify(searchData));
            this.inSearch = false;
            this.pagination = res.data.paginate;
          }
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>
